import React, { useEffect, useRef } from "react";
import "./EmojiContextMenu.css";
import archiveIcon from "../../assets/archive.svg";
import ReactDOM from "react-dom";
import deleteIcon from "../../assets/delete.svg";
import { useDispatch, useSelector } from "react-redux";
import editIcon from "../../assets/edit.svg";
import { userSelector } from "../../store/selectors";
import { ReactComponent as DeleteIcon } from "../../assets/delete-color.svg";
import { ReactComponent as EditIcon } from "../../assets/edit-color.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/archive-color.svg";
import { setCommentReaction } from "../../store/usersSlice";

const EmojiContextMenu = ({
  isOpen,
  onClose,
  isLikeVisible,
  onArchive,
  onRestore = () => {},
  emojiArray = ["❤️"],
  onDelete,
  onEdit,
  onForceDelete,
  position,
  isArchived,
  isAdmin = false,
  onAddEmoji,
  comment,
  contextMenuPosition,
}) => {
  const menuRef = useRef(null);
  const user = useSelector(userSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isAdmin) return;
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        event.target.id !== "emoji-icon"
      ) {
        onClose(event);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleSelectEmoji = (emoji, reactionId) => {
    if (isAdmin) {
      onAddEmoji(emoji);
      return;
    }

    dispatch(
      setCommentReaction({
        commentId: comment.id,
        reactionId: reactionId,
      })
    ).then((res) => {
      if (!res.error) {
        onAddEmoji(comment.id, emoji);
      }
    });
  };

  if (!isOpen) return null;

  const menu = (
    <div
      className="emoji-context-menu"
      ref={menuRef}
      style={{
        position: "absolute",
        top: contextMenuPosition.top,
        left: contextMenuPosition.left,
        zIndex: 2000,
        // minWidth: 150,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 7,
      }}
    >
      {emojiArray.map((emoji, index) =>
        !isLikeVisible && index === 0 ? null : (
          <div
            onClick={() => handleSelectEmoji(emoji, emoji.id)}
            className="emoji-context-menu-item"
          >
            <span style={{ fontSize: 22 }}>{`${emoji?.emoji || emoji}`}</span>
          </div>
        )
      )}
    </div>
  );

  return ReactDOM.createPortal(menu, document.body);
};

export default EmojiContextMenu;
